/**
 * Wraps a query function so a NOT_FOUND answer resolves to `null` instead of
 * rejecting.
 *
 * For a read where "it doesn't exist" is an ordinary answer, such as a space
 * hidden from the caller or a story PSI has no record of. Any other rejection
 * still throws, so the query reports it as an error.
 */
import { ORPCError } from '@orpc/client';

export function nullOnNotFound<TContext, TData>(
    queryFn: (context: TContext) => TData | Promise<TData>,
): (context: TContext) => Promise<TData | null> {
    return async (context) => {
        try {
            return await queryFn(context);
        } catch (error) {
            if (error instanceof ORPCError && error.code === 'NOT_FOUND') {
                return null;
            }
            throw error;
        }
    };
}
